import * as React from 'react';

interface DetailFieldProps {
  label: string;
  value?: React.ReactNode;
  emptyText?: string;
  children?: React.ReactNode;
}

export function DetailField({ label, value, emptyText = 'Not provided', children }: DetailFieldProps) {
  const content = children ?? value;
  const isEmpty = content === null || content === undefined || content === '';

  return (
    <div>
      <label className="text-xs text-muted-foreground block mb-1">{label}</label>
      <div className="text-sm">
        {isEmpty ? (
          <span className="text-muted-foreground italic">{emptyText}</span>
        ) : (
          content
        )}
      </div>
    </div>
  );
}
